import { render } from "./CategoryTestsSummary.vue?vue&type=template&id=3684d166"
import script from "./CategoryTestsSummary.vue?vue&type=script&lang=js"
export * from "./CategoryTestsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__